import * as React from "react";
import { connect } from "react-redux";
import { selectQuestInfo, selectSelectedQuest } from "../../../../selectors/selectQuestInfo";
import { QuestItem } from "./QuestItem";
import { QuestList } from "./QuestList";
var _MasterViewBaseQuests = function (_a) {
    var selectedQuest = _a.selectedQuest, completedQuestIds = _a.completedQuestIds, quests = _a.quests;
    return (React.createElement("div", { key: "MasterViewBaseQuests", className: "quest-container" },
        React.createElement(QuestList, null),
        React.createElement("div", { className: "quest-item" }, selectedQuest && (React.createElement(QuestItem, { quest: selectedQuest, completed: completedQuestIds.indexOf(selectedQuest.id) !== -1 ||
                !quests.some(function (q) { return q.questId === selectedQuest.id; }) })))));
};
var mapState = function (state) {
    return {
        completedQuestIds: selectQuestInfo(state).completedQuestIds,
        quests: state.questInfo.quest,
        selectedQuest: selectSelectedQuest(state),
    };
};
export var MasterViewBaseQuests = connect(mapState)(_MasterViewBaseQuests);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/MasterViewBaseQuests.tsx
// module id = 2658
// module chunks = 3